import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { ErrorData } from '../../classes/error-data';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorWarningTypes } from '../../enums/error-warning-types.enum';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorComponent implements OnInit {
  public ErrorWarningTypes = ErrorWarningTypes;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorData) {}

  ngOnInit() {}
}
